import { MailConversationStatusChangeData } from "../../handler/mail/ws-types";
import EventBus from "../event-bus";
const conversationStatusChangeHook =
  new EventBus<MailConversationStatusChangeData>(
    "conversationStatusChangeHook"
  );

export default conversationStatusChangeHook;
